import React from 'react';
import {flexRender} from '@tanstack/react-table';

export const QueryToolBody = ({tableBodyRef, rows, totalSize, allColumns}) => (
    <div ref={tableBodyRef} className="rt-tbody">
        {rows.map(row => (
            <div key={row.id} className="rt-tr-group" role="rowgroup">
                <div className="rt-tr" role="row" style={{minWidth: totalSize}}>
                    {row.getVisibleCells().map(cell => (
                        <div
                            key={cell.id}
                            className="rt-td"
                            style={{
                                flex: `${cell.column.getSize()} 0 auto`,
                                width: cell.column.getSize(),
                                maxWidth: cell.column.getSize(),
                            }}
                        >
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </div>
                    ))}
                </div>
            </div>
        ))}
        {Array.from({length: Math.max(10 - rows.length, 0)}, (_, index) => (
            <div key={`pad-${index}`} className={`rt-tr-group -pad-${index}`} role="rowgroup">
                <div className="rt-tr -padRow" role="row" style={{minWidth: totalSize}}>
                    {allColumns.map(column => (
                        <div
                            key={column.id}
                            className="rt-td"
                            style={{
                                flex: `${column.getSize()} 0 auto`,
                                width: column.getSize(),
                                maxWidth: column.getSize(),
                            }}
                        />
                    ))}
                </div>
            </div>
        ))}
    </div>
);
